import React from 'react';
import styles from './CardComponent.module.scss';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { useTranslation } from 'react-i18next';



export const CardComponent: React.FC<DynamicComponentProps> = ({ structure, children }: React.PropsWithChildren<DynamicComponentProps>) => {
    const { t: translate } = useTranslation();

    return (
        <div className={styles.container}>
            <h2 className={styles.header}>{translate(structure.header || '')}</h2>
            <div className={styles.inputGroup}>
                {children}
            </div>
        </div>
    );
}